import vuex from "src/vuex"
import UserRole from "src/util/valueObjects/userRole";
import * as Cookies from "js-cookie";

export default (to, from, next) => {
  if (Cookies.getJSON("token").user.role.id !== UserRole.FINTECH.index)
    vuex.dispatch("redirectToMainMenu");

  next();
};
